import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { selectIsMobileMQ } from 'core/modules/MediaQueries/selectors';
import { isImageAssetVideo } from 'core/utils/helpers/checkIfImageAssetVideo';
import ComponentErrorBoundary from 'core/modules/ErrorBoundaries/ComponentErrorBoundary';

import { fetchPlacements } from 'core/actions/ocapi';

import {
  selectHolidayBorderLeftConfig, selectHolidayBorderLeftIsLoading,
  selectHolidayBorderLeftIsLoaded, selectHolidayBorderLeftImage,
  selectHolidayBorderRightConfig, selectHolidayBorderRightIsLoading,
  selectHolidayBorderRightIsLoaded, selectHolidayBorderRightImage,
  selectHolidayBorderRightImageAlternateText, selectHolidayBorderLeftImageAlternateText,
} from './selectors';

import HolidayBorderItem from './components/HolidayBorderItem';

import './HolidayBorder.scss';

function HolidayBorder() {
  const holidayBorderLeftConfig = useSelector(selectHolidayBorderLeftConfig);
  const holidayBorderLeftIsLoading = useSelector(selectHolidayBorderLeftIsLoading);
  const holidayBorderLeftIsLoaded = useSelector(selectHolidayBorderLeftIsLoaded);
  const holidayBorderLeftImage = useSelector(selectHolidayBorderLeftImage);
  const holidayBorderLeftImgAltText = useSelector(selectHolidayBorderLeftImageAlternateText);
  const holidayBorderRightConfig = useSelector(selectHolidayBorderRightConfig);
  const holidayBorderRightIsLoading = useSelector(selectHolidayBorderRightIsLoading);
  const holidayBorderRightIsLoaded = useSelector(selectHolidayBorderRightIsLoaded);
  const holidayBorderRightImage = useSelector(selectHolidayBorderRightImage);
  const holidayBorderRightImgAltText = useSelector(selectHolidayBorderRightImageAlternateText);
  const isMobileMQ = useSelector(selectIsMobileMQ);
  const dispatch = useDispatch();

  const imageIsVideo = isImageAssetVideo(holidayBorderLeftImage) && isImageAssetVideo(holidayBorderRightImage);

  useEffect(() => {
    if (isMobileMQ) {
      return;
    }

    if (!holidayBorderLeftIsLoading && !holidayBorderLeftIsLoaded) {
      const { api: { params, options } } = holidayBorderLeftConfig;
      dispatch(fetchPlacements(params, { ...options }));
    }

    if (!holidayBorderRightIsLoading && !holidayBorderRightIsLoaded) {
      const { api: { params, options } } = holidayBorderRightConfig;
      dispatch(fetchPlacements(params, { ...options }));
    }
  }, [isMobileMQ]);

  if (!holidayBorderLeftImage || !holidayBorderRightImage || isMobileMQ) {
    return null;
  }

  return (
    <>
      <HolidayBorderItem
        isVideo={imageIsVideo}
        src={holidayBorderRightImage}
        className="mn_holidayWrapRight"
        imageAlternateText={holidayBorderRightImgAltText}
      />
      <HolidayBorderItem
        isVideo={imageIsVideo}
        src={holidayBorderLeftImage}
        className="mn_holidayWrapLeft"
        imageAlternateText={holidayBorderLeftImgAltText}
      />
    </>
  );
}

export default (props) => <ComponentErrorBoundary><HolidayBorder {...props} /></ComponentErrorBoundary>;
